import { useLayoutEffect, useRef, useState } from 'react'
import { ClickAwayListener, InputBase, Typography } from '@mui/material'

const defaultRenameMaxWidth = 240

export interface RenamableNodeNameProps {
  initialName: string
  isRenaming: boolean
  setIsRenaming: (value: boolean) => void
  onRenameSubmit: (name: string) => void
  renameMaxWidth?: number
}

export function RenamableNodeName({
  initialName,
  isRenaming,
  setIsRenaming,
  onRenameSubmit,
  renameMaxWidth = defaultRenameMaxWidth,
}: RenamableNodeNameProps) {
  const [name, setName] = useState(initialName)
  const [inputWidthPx, setInputWidthPx] = useState(0)
  const spanRef = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    if (isRenaming && spanRef.current) {
      setInputWidthPx(spanRef.current.offsetWidth)
    }
  }, [name, isRenaming])

  if (isRenaming) {
    return (
      <ClickAwayListener onClickAway={() => setIsRenaming(false)}>
        <form
          onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            onRenameSubmit(name)
            setIsRenaming(false)
          }}
        >
          <Typography
            ref={spanRef}
            component="span"
            aria-hidden
            sx={{ position: 'absolute', left: '-9999px', visibility: 'hidden', whiteSpace: 'pre' }}
          >
            {name || ' '}
          </Typography>
          <InputBase
            autoFocus
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
            sx={{ '& input': { typography: 'body1', width: inputWidthPx || 'auto', maxWidth: renameMaxWidth } }}
          />
        </form>
      </ClickAwayListener>
    )
  }

  return <Typography>{name}</Typography>
}
